/**
 * Escapes all special regular expression characters in the given value so it
 * can be safely embedded inside a `RegExp` pattern as a literal string.
 *
 * @param value - The raw string to escape.
 * @returns The value with regex metacharacters escaped.
 */
export const escapeRegExp: (value: string) => string = (value) => {
  const replacement = String.raw`\$&`;

  return value.replace(/[.*+?^${}()|[\]\\]/g, replacement);
};
